import { Component, computed, Inject, model, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faClose, faGlobe } from '@fortawesome/pro-regular-svg-icons';

import { UiAdminModule } from '@eiq/ui';

import { TranslationExportOptions } from '../../../models/translations/translation-export-options.interface';

@Component({
  standalone: true,
  templateUrl: 'export-translations-dialog.component.html',
  styleUrls: ['./export-translations-dialog.component.scss'],
  imports: [FontAwesomeModule, FormsModule, MatCheckbox, MatDialogModule, UiAdminModule]
})
export class ExportTranslationsDialogComponent implements OnInit {
  missing$ = model(true);
  outdated$ = model(true);
  ignored$ = model(true);

  all$ = computed(() => this.missing$() && this.outdated$() && this.ignored$());
  canExport$ = computed(() => this.missing$() || this.outdated$() || this.ignored$());

  faClose = faClose;
  faGlobe = faGlobe;

  constructor(
    private dialogRef: MatDialogRef<ExportTranslationsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { languageName: string }
  ) {}

  ngOnInit(): void {
    this.dialogRef.addPanelClass('eiq-export-translations-dialog');
  }

  onAllChange(checked: boolean): void {
    this.missing$.set(checked);
    this.outdated$.set(checked);
    this.ignored$.set(checked);
  }

  onExport(): void {
    const options: TranslationExportOptions = {
      all: this.all$(),
      missing: this.missing$(),
      outdated: this.outdated$(),
      ignored: this.ignored$()
    };

    this.dialogRef.close(options);
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
